import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AlertController, LoadingController, Platform, ToastController} from '@ionic/angular';
import {LocalDataSource} from '../../../ng2-smart-table/lib/data-source/local/local.data-source';
import {ContactData} from '../../../interfaces/contact-data';
import {TeamPage} from '../../modals/team/team';
import {User} from '../../../providers/user/user';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {PatientData} from '../../../interfaces/patient-data';
import {UserOptions} from '../../../interfaces/userOptions';
import {ButtonViewComponent} from '../button-view/button-view.component';
import {ModalService} from '../../../providers/modal.service';
import {AccountAddPage} from '../../../pages/account/account-add/account-add';
import {Page} from '../../../page-controller/page.type';
import {PageController} from '../../../page-controller/page.controller';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/** //onClick('removeConnection')
 * Generated class for the ContactDataComponent component.
 */
@Component({
  selector: 'app-contact-data',
  templateUrl: 'contact-data.html',
  styleUrls: ['./contact-data.scss']
})
export class ContactDataComponent implements OnInit{

  @Input()
  transmitterId: string;
  @Output()
  outContractData = new EventEmitter();
  @Output() selectedRow = new EventEmitter();
  data: LocalDataSource = new LocalDataSource();


  isCore = true;
  settings: any;

  constructor(private alertController: AlertController, private toastController: ToastController, private pageController: PageController,
              private userProvider: User, private modalCtrl: ModalService,
              private patientProvider: PatientDataProvider, private translate:TranslateService,
              private loadingController: LoadingController, private plf: Platform) {

    this.isCore = this.plf.is('desktop'); // TODOALEX
  }

  async ngOnInit() {
    if(!this.settings) {
      let translateData = await firstValueFrom(this.translate.get(['Order', 'Type', 'Member', 'Doctor', 
      'ReferencePerson', 'AuthorisedRepresentative', 'NursingSpecialist', 'NursingService', 'FirstName', 'LastName',
      'Company', 'Street', 'Zip', 'City', 'NoContactsFound'
    ]));
  
      translateData = Object.values(translateData);
      this.settings = {
        columns: {
          sort: {
            title: translateData[0],
            sort: true,
            sortDirection: 'asc'
          },
          type: {
            title: translateData[1],
            editor: {
              type: 'list',
              config: {
                list: [
                  {value: 'Angehöriger', title: translateData[2]},
                  {value: 'Arzt', title: translateData[3]},
                  {value: 'Bezugsperson', title: translateData[4]},
                  {value: 'Bevollmächtigter', title: translateData[5]},
                  {value: 'Pflegefachkraft', title: translateData[6]},
                  {value: 'Pflegedienst', title: translateData[7]}
                ]
              }
            }
          },
          firstname: {
            title: translateData[8]
          },
          lastname: {
            title: translateData[9]
          },
          company: {
            title: translateData[10]
          },
          street: {
            title: translateData[11]
          },
          zip: {
            title: translateData[12]
          },
          city: {
            title: translateData[13]
          }
        },
        actions: null,
        filter: null,
        pager: {
          perPage: 5
        },
        hideSubHeader: false,
        noDataMessage: translateData[14]
      };
    }

   
  }

  @Input() set test(data) {
    if (data) {
      this.data.refresh();
    }
  }


  @Input() set contractData(data: Array<ContactData>) {
    (async () => {
      await this.data.load(data);
    })();
  }

  private expandSettings() {

    this.settings.actions = {
      edit: true,
      delete: true,
      add: true,
      custom: [
        {
          name: 'takeOverData',
        },
      ]
    };
    this.settings.hideSubHeader = false;
    this.settings.add = {
      addButtonContentIcon: 'person-add',
      createButtonContentIcon: 'checkmark-circle-outline',
      cancelButtonContentIcon: 'close',
      confirmCreate: true
    };
    this.settings.delete = {
      deleteButtonContentIcon: 'trash',
      confirmDelete: true
    };
    this.settings.edit = {
      editButtonContentIcon: 'create',
      saveButtonContentIcon: 'checkmark-circle-outline',
      cancelButtonContentIcon: 'close',
      confirmSave: true
    };

    this.settings.columns.appId = {
      title: 'Konto',
      type: 'custom',
      filter: false,
      renderComponent: ButtonViewComponent,
      onComponentInitFunction: (instance) => {
        instance.save.subscribe(data => {
          return this.customButton({action: data.action, data: data.row});
        });
      }
    };
    
  }

  @Input() set isEdit(value) {
    if (value === true) {
      if(!this.settings) {
        this.ngOnInit().then(() => {
          this.expandSettings();
        })
      }
    } else {
      if(!this.settings) {
        this.ngOnInit().then(() => {
          this.settings.actions = {
            edit: false,
            delete: false,
            add: false
          };
          this.settings.hideSubHeader = true;
        })
      }
    }
  }

  rowSelect(rowData: any) {
    if (rowData.source) {
      const x = rowData.source.data.indexOf(rowData.data);
      rowData = rowData.source.data[x];
    }

    (this.data as any).filteredAndSorted.map((row: any) => {
      row.active = false;
    });

    rowData.active = true;

    const contact = new ContactData();
    rowData = Object.assign(contact, rowData);
    this.selectedRow.emit(rowData);
  }

  async customButton(ev: any) {

    if (ev.action === 'takeOverData') {
      const modal = await this.modalCtrl.openModal(TeamPage);
      await modal.present();
      const {data} = await modal.onDidDismiss();
      if (data) {
        ev.data.contactNumbers = ev.data.contactNumbers.concat(data);
        this.data.refresh();
        this.rowSelect(ev.data);
      }
    } else if (ev.action === 'register') {
      const modal = await this.modalCtrl.openModal(AccountAddPage, {relationOnly: ev.data, id: this.transmitterId});
      await modal.present();
      const {data} = await modal.onDidDismiss();
      const _new_row = data || ev.data.appId;
      if (_new_row) {
        this.data.update(ev.data, _new_row);
      }
    } else if (ev.action === 'removeConnection') {
      const alert = await this.alertController.create({
        message: this.translate.instant('Message.DeleteLink'),
        buttons: [
          {
            text: this.translate.instant('Cancel'),
            role: 'cancel'
          }, {
            text: this.translate.instant('Delete'),
            cssClass: 'alert-success-button',
            handler: async () => {
              const load = await this.loadingController.create({message: this.translate.instant('Loading.UserAdd')});
              load.present();

              const appId = ev.data.appId;
              // suchen nach Benutzer mit appId -> eindeutige userId
              this.userProvider.get(appId).then((data: any) => {
                const user: UserOptions = data.data.data.data.docs[0];
                if (user) {
                  // prüfen, ob die Benutzer-AlarmGruppen die PatientId -- transmitterId -- enthält
                  const index = user.profile.alertGroups.indexOf(this.transmitterId.toString()); // TODOALEX, die Id wird nicht gelöscht
                  // wenn ja, dann löschen aus dem array
                  if (index !== -1) {
                    user.profile.alertGroups.splice(index, 1);
                  }
                  // User speichern
                  this.userProvider.update(user).then(_ => {
                    // dann den Patienten bei transmitterId suchen
                    this.patientProvider.query({transmitterId: this.transmitterId}).subscribe((val: any) => {
                      const patient: PatientData = val.data.data.data.docs[0];
                      patient.contacts.forEach((e) => {
                        // wenn Contact[i] die appId hat und die ist wie bei dem Angehörigen
                        if (e.appId && e.appId === appId) {
                          // dann das Field löschen
                          delete e.appId;

                          // und den Patienten speichern
                          this.patientProvider.update(patient).subscribe(async (updateRes: any) => {
                            patient._rev = updateRes.data.data.data.rev;
                            let _newRow = ev.data;
                            _newRow.appId = '';
                            this.data.update(ev.data, _newRow).then(() => {
                              _newRow = null;
                            });
                            load.dismiss();
                            const toast = await this.toastController.create({
                              message: this.translate.instant('Message.DeleteLinkSuccess'),
                              duration: 3000,
                              position: 'top'
                            });
                            toast.present();
                            // TODOALEX die Tabellenzeile aktualisieren
                          });
                        }
                      });

                    });
                  });
                }
              }).catch(async error => {
                load.dismiss();
                console.error(error);
                const toast = await this.toastController.create({
                  message: this.translate.instant('Massage.Error'),
                  duration: 3000,
                  position: 'top'
                });
                toast.present();
              });

            }
          }
        ]
      });
      alert.present();


    } else if (ev.action === 'openProfile') {
      await this.pageController.navigateForward(Page.Account, {id:ev.data.appId});
    }
  }

  onEdit(event) {
    event.confirm.promise.then(() => {
      this.data.getAll()
        .then((data) => {
          this.outContractData.emit(data);
        });
    });
    event.confirm.resolve();
  }

  onCreate(event) {
    const newContact = new ContactData();
    event.newData = Object.assign(newContact, event.newData);

    this.rowSelect(event.newData);

    event.confirm.promise.then(() => {
      this.data.getAll()
        .then((data) => {
          data = data.map((rowData) => {
            const contact = new ContactData();
            return Object.assign(contact, rowData);
          });
          this.outContractData.emit(data);
        });

    });
    event.confirm.resolve();
  }

  async deleteConfirm(event) {
    const alert = await this.alertController.create({
      header: this.translate.instant('Warning'),
      message: this.translate.instant('Message.DeleteContact'),
      buttons: [
        {
          text: this.translate.instant('Cancel'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('Delete'),
          handler: () => {

            event.confirm.promise.then(() => {
              this.data.getAll()
                .then((data) => {
                  this.outContractData.emit(data);
                });

            });

            event.confirm.resolve();
          }
        },
      ]
    });
    alert.present();
  }


}
